import { render, staticRenderFns } from "./share_success.vue?vue&type=template&id=55f8ac32&scoped=true&"
import script from "./share_success.vue?vue&type=script&lang=js&"
export * from "./share_success.vue?vue&type=script&lang=js&"
import style0 from "./share_success.vue?vue&type=style&index=0&id=55f8ac32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8ac32",
  null
  
)

export default component.exports